import { getErrorPayload } from '@application/common/helpers/api-helper';
import UserService from '@infrastructure/user-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
import { toggleDisableUserConfirm, toggleEnableUserConfirm, toggleUserDetailsModal } from './adminUserSlice';
export const getUsersAsync = createAsyncThunk('users/getAll', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserService.getUsers(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserByIdAsync = createAsyncThunk('users/getUserById', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserService.getUserById(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCurrentUserAsync = createAsyncThunk('users/getCurrentUserById', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserService.getCurrentUser();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserByStatusAsync = createAsyncThunk('users/getUserByStatus', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserService.getUserByStatus(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserAsync = createAsyncThunk('users/updateUserProfile', async (request, { rejectWithValue, fulfillWithValue, dispatch, getState }) => {
    try {
        const response = await UserService.updateUser(request.id, request);
        dispatch(toggleUserDetailsModal());
        dispatch(addSuccessNotification('Profile updated successfully!'));
        const { getUserDetailsRequest } = getState().user;
        dispatch(getUsersAsync(getUserDetailsRequest));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
// export const getUserInvoicesAsync = createAsyncThunk<
//     // PaginatedList<InvoiceDto>,
//     UserInvoicesRequestDto,
//     { rejectValue: ApiError | undefined }
// >('users/userInvoiceById', async (request, { rejectWithValue, fulfillWithValue }) => {
//     try {
//         const response = await InvoiceService.getUserInvoicesById(request);
//         return fulfillWithValue(response.data);
//     } catch (error) {
//         return rejectWithValue(getErrorPayload(error));
//     }
// });
// export const getUserDebtorsAsync = createAsyncThunk<DebtorDto[], string, { rejectValue: ApiError | undefined }>(
//     'users/userDebtorById',
//     async (request, { rejectWithValue, fulfillWithValue }) => {
//         try {
//             const response = await DebtorService.getUserDebtorsById(request);
//             return fulfillWithValue(response.data);
//         } catch (error) {
//             return rejectWithValue(getErrorPayload(error));
//         }
//     }
// );
// export const getUserBalanceAsync = createAsyncThunk<BalanceDto, string, { rejectValue: ApiError | undefined }>(
//     'users/userBalanceById',
//     async (request, { rejectWithValue, fulfillWithValue }) => {
//         try {
//             const response = await FreelancerService.getFreelancerBalance(request);
//             return fulfillWithValue(response.data);
//         } catch (error) {
//             return rejectWithValue(getErrorPayload(error));
//         }
//     }
// );
// export const updateUserBalanceAsync = createAsyncThunk<BalanceDto, UpdateBalanceDto, { rejectValue: ApiError | undefined }>(
//     'users/updateBalanceById',
//     async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
//         try {
//             const response = await FreelancerService.updateFreelancerBalance(request);
//             dispatch(toggleUserOutStandingBalanceModal());
//             dispatch(addSuccessNotification('Balance updated successfully!'));
//             return fulfillWithValue(response.data);
//         } catch (error) {
//             return rejectWithValue(getErrorPayload(error));
//         }
//     }
// );
export const disableUserAsync = createAsyncThunk('users/disableUser', async (userId, { rejectWithValue, fulfillWithValue, dispatch, getState }) => {
    try {
        const response = await UserService.disableUser(userId);
        dispatch(addSuccessNotification('User disabled successfully!'));
        const getUsersRequest = getState().user.getUserDetailsRequest;
        dispatch(toggleDisableUserConfirm());
        dispatch(getUsersAsync(getUsersRequest));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const enableUserAsync = createAsyncThunk('users/enableUser', async (userId, { rejectWithValue, fulfillWithValue, dispatch, getState }) => {
    try {
        const response = await UserService.enableUser(userId);
        dispatch(addSuccessNotification('User enabled successfully!'));
        const getUsersRequest = getState().user.getUserDetailsRequest;
        dispatch(toggleEnableUserConfirm());
        dispatch(getUsersAsync(getUsersRequest));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserByEmailAsync = createAsyncThunk('users/getUserByEmail', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserService.getUserByEmail(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
